 <template>
   <div>
     <div class="chart-section"></div>
     <div class="details-block">Select a pie slice to view details</div>
   </div>
</template>

<script>
  import { GoogleCharts } from 'google-charts';
  
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    unitStyle: {
      type: String,
      required: true
    },
    itemUnitName: {
      type: String,
      required: true
    },
    displayUnit: {
      type: String,
      required: true
    },
    is3d: {
      type: Boolean,
      required: true
    },
    arrayData: {
      type: String,
      required: true
    },
    colorData: {
      type: String,
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  setup() {
  },
  created() {
  },
  mounted() {
    this.loadCharts();
  },
  methods: {
    loadCharts() {
      GoogleCharts.load(this.drawChart);
    },
    drawChart() {
      var table = new GoogleCharts.api.visualization.DataTable();

      if (table === undefined) {
        console.log('Error loading Google charts api');
        return;
      }

      var dataJsonResult = JSON.parse(this.arrayData);

      // Create the using the data Array
      var chartData = dataJsonResult.map(function (item) {
        return [item.ItemTitle, item.ItemValue, item.ItemDescription];
      });

      table.addColumn('string', this.itemUnitName);
      table.addColumn('number', this.displayUnit);
      // A column for custom tooltip content
      table.addColumn({ type: 'string', role: 'tooltip' });
      table.addRows(chartData);

      var options = {
        backgroundColor: 'transparent',
        chartArea: {
          left: 20,
          top: 0,
          width: '100%',
          height: '100%'
        },
        title: this.title,
        is3D: this.is3d,
        slices: JSON.parse(this.colorData),
        tooltip: {
          trigger: 'none'
        },
        pieSliceText: 'percentage',
        legend: {
          alignment: 'center',
          textStyle: {
            bold: true
          }
        }
      }

      if (this.unitStyle === 'usd') {
        var formatter = new GoogleCharts.api.visualization.NumberFormat({
          prefix: '$'
        });

        formatter.format(table, 1);
        options['pieSliceText'] = 'value';
      }

      if (this.unitStyle === 'million') {
        var formatter = new GoogleCharts.api.visualization.NumberFormat({
          pattern: '$###.#M'
        });

        formatter.format(table, 1);
        options['pieSliceText'] = 'value';
      }
      var chartSection = this.$el.querySelector('.chart-section');
      var detailsBlock = this.$el.querySelector('.details-block');

      // Create the chart
      const chart = new GoogleCharts.api.visualization.PieChart(chartSection);

      // Add a listener to the chart to display the details of the selected slice
      GoogleCharts.api.visualization.events.addListener(chart, 'select', function () {
        var selection = chart.getSelection();
        if (selection.length) {
          var row = selection[0].row;
          var details = table.getValue(row, 2);
          detailsBlock.textContent = details;
        }
      });


      chart.draw(table, options);

      // Redraw the chart when the window resizes
      // Workaround for the chart to be responsive
      window.addEventListener('resize', function () {
        chart.draw(table, options);
      });

      GoogleCharts.api.visualization.events.addListener(chart, 'click', function (entry) {
        chart.setSelection([{ row: entry.row }]);
      });

      GoogleCharts.api.visualization.events.addListener(chart, 'onmouseover', function (entry) {
        var row = entry.row;
        var details = table.getValue(row, 2);
        detailsBlock.textContent = details;
      });

      GoogleCharts.api.visualization.events.addListener(chart, 'onmouseout', function (entry) {
        chart.setSelection([]);
      });  

      }
  },
  components: {
  }
}
</script>
